import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TOOLS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TOOLS');
export const TOOLS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(TOOLS_CRUD_ACTION_CONSTANTS);
